import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

const useGiftPermissions = () => {
  const [giftAccess, setGiftAccess] = useState(false);
  const {
    giftInfo: { products: giftProducts },
   
    giftInfo: giftsActiveOnCampaign,
   
  } = useSelector((state) => state.Gift);
   

  const { participantGroups: participantGroupData } = useSelector(
    (state) => state.ParticipantGroups
  );

  useEffect(() => {
    if (!giftProducts && !giftsActiveOnCampaign && participantGroupData) return;

    const participantGroupNames = participantGroupData.map(
      (group) => group.name
    );

    const filterProductsByGroups = (products) => {
      return products.filter(
        (product) =>
          product.groups &&
          product.groups.some((group) => participantGroupNames.includes(group))
      );
    };

    const filterProductsWithoutGroups = (products) => {
      return products.filter(
        (product) => !product.groups || product.groups.length === 0
      );
    };

    const isGroupActive = giftProducts.some(
      (product) => product.groups && product.groups.length > 0
    );

    if (giftProducts.length > 0 && isGroupActive) {
      const filteredGifts = [
        ...filterProductsByGroups(giftProducts),
        ...filterProductsWithoutGroups(giftProducts),
      ];

      if (filteredGifts.length === 0) {
        setGiftAccess(false);
        return;
      }

      setGiftAccess(true);
    }
  }, [giftProducts, participantGroupData, giftsActiveOnCampaign]);

  return giftAccess;
};

export default useGiftPermissions;
